export default {
	bloglist: {
		all: [
			{
				title: 'How to Uninstall GBWhatsApp Safely from Your Android',
				poster: require('@/assets/uninstall-gbwhatsapp.webp'),
				desc: 'Learn how to uninstall GBWhatsApp safely from your Android device. Protect your data, free up space, and switch to secure messaging alternatives easily.',
				name: 'en-blog1',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/blogs/uninstall-gbwhatsapp-safely/',
                link:'https://gbwaapplus.com/blogs/',
				date: '10/5/2025',
			},
			{
				title: 'Unlocking GB WhatsApp Anti Revoke Messages Feature',
				poster: require('@/assets/unlock-anti-revoke-message.webp'),
				desc: 'Discover how GB WhatsApp’s Anti Revoke messages feature lets you read deleted chats, enhancing your control, clarity, and messaging experience.',
				name: 'en-blog2',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/blogs/unlocking-gb-whatsapp-anti-revoke-messages/',
                link:'https://gbwaapplus.com/blogs/',
				date: '15/5/2025',
			},
			{
				title: 'How to Use GB WhatsApp without Being Banned ',
				poster: require('@/assets/gbwhatsapp-anti-ban.webp'),
				desc: 'Discover how GB WhatsApp’s Anti Revoke messages feature lets you read deleted chats, enhancing your control, clarity, and messaging experience.',
				name: 'en-blog3',
				column: 'Troubleshooting',
				url: 'https://gbwaapplus.com/use-gb-whatsapp-without-being-banned/',
                link:'https://gbwaapplus.com/blogs/',
				date: '19/5/2025',
			},
			{
				title: 'What is Blue WhatsApp Plus?',
				poster: require('@/assets/blog-4.webp'),
				desc: 'Explore what Blue WhatsApp Plus offers, from extra features to privacy upgrades. Discover how it differs from the official WhatsApp in our full guide.',
				name: 'en-blog4',
				column: 'WhatsApp Mods',
				url: 'https://gbwaapplus.com/what-is-blue-whatsapp-plus/',
                link:'https://gbwaapplus.com/blogs/',
				date: '27/5/2025',
			},
			{
				title: 'Download WhatsApp Status Video Easily with GBWhatsApp',
				poster: require('@/assets/download-whatsapp-status-video.webp'),
				desc: "Save contacts status videos with one click by using GB WhatsApp. Read this blog to learn the simple steps. It's easy to save WhatsApp status videos.",
				name: 'en-blog5',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/blogs/download-whatsapp-status-video/',
                link:'https://gbwaapplus.com/blogs/',
				date: '10/6/2025',
			},
			{
				title: 'How to Customize GB WhatsApp on Your Device',
				poster: require('@/assets/customize-gb.webp'),
				desc: 'Learn how to easily customize GB WhatsApp with unique themes, fonts, and emojis. Personalize your chat experience and make the app truly yours with simple steps.',
				name: 'en-blog6',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/how-to-customize-gb-whatsapp-on-your-device/',
                link:'https://gbwaapplus.com/blogs/',
				date: '27/6/2025',
			},
			{
				title: 'New Release: GB WhatsApp Updated v18.50 Version',
				poster: require('@/assets/gbWhatsAppUpdated.webp'),
				desc: 'GB WhatsApp v18.50 is here with better privacy, new features, smoother performance, and full customization. Download the latest version now!',
				name: 'en-blog7',
				column: 'News',
				url: 'https://gbwaapplus.com/new-release-gb-whatsapp-updated-v18.50-version/',
                link:'https://gbwaapplus.com/blogs/',
				date: '07/07/2025',
			},
			{
				title: 'GB WhatsApp Support: How to Get Help & Fix Issues',
				poster: require('@/assets/gbWhatsappSupport.webp'),
				desc: 'GB WhatsApp Support helps users resolve login errors, feature glitches, and update problems quickly. Learn how to get the right assistance and fix issues fast.',
				name: 'en-blog8',
				column: 'Troubleshooting',
				url: 'https://gbwaapplus.com/gb-whatsapp-support-how-to-get-help-and-fix-issues/',
                link:'https://gbwaapplus.com/blogs/',
				date: '20/07/2025',
			},
			{
				title: 'Can I use GBWhatsApp and WhatsApp with the same phone number?',
				poster: require('@/assets/blog-9.webp'),
				desc: 'Wondering if you can use GBWhatsApp and WhatsApp with the same number? Learn the risks, limitations, and best practices for dual messaging apps.',
				name: 'en-blog9',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/can-i-use-gbwhatsapp-and-whatsapp-with-same-number/',
                link:'https://gbwaapplus.com/blogs/',
				date: '01/08/2025',
			},
			{
				title: 'How to Restore Deleted Media on GBWhatsApp Without Backup',
				poster: require('@/assets/blog-10.webp'),
				desc: 'Restore GBWhatsApp deleted media quickly without backup using these proven methods. Recover your photos, videos, and audio files effortlessly today.',
				name: 'en-blog10',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/restore-deleted-media-on-gbwhatsapp-without-backup/',
                link:'https://gbwaapplus.com/blogs/',
				date: '11/08/2025',
			},
			{
				title: 'How to Fix GBWhatsApp Not Working on Android',
				poster: require('@/assets/blog-11.webp'),
				desc: 'How to fix GBWhatsApp not working on Android with easy steps to solve crashes, connection errors, and update problems quickly.',
				name: 'en-blog11',
				column: 'Troubleshooting',
				url: 'https://gbwaapplus.com/how-to-fix-gbwhatsapp-not-working-on-android/',
                link:'https://gbwaapplus.com/blogs/',
				date: '19/08/2025',
			},
			{
				title: 'What is WhatsApp Aero?',
				poster: require('@/assets/blog-12.webp'),
				desc: 'WhatsApp Aero brings flexible design, privacy tools, and improved media sharing to Android. Ideal for users who love personalization and a unique interface beyond regular WhatsApp.',
				name: 'en-blog12',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/what-is-whatsapp-aero/',
                link:'https://gbwaapplus.com/blogs/',
				date: '28/08/2025',
			},
			{
				title: 'Does GBWhatsApp Really Improve Privacy? A Deep Dive',
				poster: require('@/assets/blog-13-1.webp'),
				desc: 'GBWhatsApp promises advanced privacy settings, from hiding online status to locking chats. But does it really improve privacy compared to the official WhatsApp? Here\'s an honest breakdown.',
				name: 'en-blog13',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/gbwhatsapp-privacy/',
                link:'https://gbwaapplus.com/blogs/',
				date: '26/09/2025',
			},
			{
				title: 'Safeguard Your Chats: How to Back Up Your Data on GBWhatsApp？',
				poster: require('@/assets/blog-14-1.webp'),
				desc: 'Easily back up GBWhatsApp data to safeguard your chats, photos, and media. Ensure secure storage and seamless recovery with verified backup methods.',
				name: 'en-blog14',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/backup-gbwhatsapp-data/',
                link:'https://gbwaapplus.com/blogs/',
				date: '20/10/2025',
			},
			{
				title: 'Exploring GBWhatsApp\'s Hidden Gem: The Voice Changer Feature',
				poster: require('@/assets/blog-15-1.webp'),
				desc: 'A deep look into GBWhatsApp\'s Voice Changer — how it works, how to enable it, and why users love this fun, expressive tool.',
				name: 'en-blog15',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/gbwhatsapp-voice-changer-feature/',
                link:'https://gbwaapplus.com/blogs/',
				date: '27/10/2025',
			},
			{
				title: 'How to Use Live Wallpapers in GBWhatsApp Chat Screen',
				poster: require('@/assets/blog-16-1.webp'),
				desc: 'Bring your chats to life by setting live wallpapers in GBWhatsApp — subtle motion, personal style, and a fresh look for your daily conversations.',
				name: 'en-blog16',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/gbwhatsapp-live-wallpapers/',
				link:'https://gbwaapplus.com/blogs/',
				date: '04/11/2025',
			},
			{
				title: 'How to Fix GB WhatsApp Not Sending or Receiving Messages',
				poster: require('@/assets/blog-17.webp'),
				desc: 'Comprehensive solutions for GB WhatsApp not sending or receiving messages. Step-by-step troubleshooting for sending and receiving failures, network issues, and connection errors.',
				name: 'en-blog17',
				column: 'Troubleshooting',
				url: 'https://gbwaapplus.com/fix-gbwhatsapp-message-sending-receiving/',
				link:'https://gbwaapplus.com/blogs/',
				date: '18/11/2025',
			},
		],
		tutorial: [
			{
				title: 'How to Uninstall GBWhatsApp Safely from Your Android',
				poster: require('@/assets/uninstall-gbwhatsapp.webp'),
				desc: 'Learn how to uninstall GBWhatsApp safely from your Android device. Protect your data, free up space, and switch to secure messaging alternatives easily.',
				name: 'en-blog1',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/blogs/uninstall-gbwhatsapp-safely/',
				date: '10/5/2025',
			},
			{
				title: 'Unlocking GB WhatsApp Anti Revoke Messages Feature',
				poster: require('@/assets/unlock-anti-revoke-message.webp'),
				desc: 'Discover how GB WhatsApp’s Anti Revoke messages feature lets you read deleted chats, enhancing your control, clarity, and messaging experience.',
				name: 'en-blog2',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/blogs/unlocking-gb-whatsapp-anti-revoke-messages/',
				date: '15/5/2025',
			},
			{
				title: 'Download WhatsApp Status Video Easily with GBWhatsApp',
				poster: require('@/assets/download-whatsapp-status-video.webp'),
				desc: "Save contacts status videos with one click by using GB WhatsApp. Read this blog to learn the simple steps. It's easy to save WhatsApp status videos.",
				name: 'en-blog5',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/blogs/download-whatsapp-status-video/',
				date: '10/6/2025',
			},
			{
				title: 'How to Customize GB WhatsApp on Your Device',
				poster: require('@/assets/customize-gb.webp'),
				desc: 'Learn how to easily customize GB WhatsApp with unique themes, fonts, and emojis. Personalize your chat experience and make the app truly yours with simple steps.',
				name: 'en-blog6',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/how-to-customize-gb-whatsapp-on-your-device/',
				date: '27/6/2025',
			},
			{
				title: 'Can I use GBWhatsApp and WhatsApp with the same phone number?',
				poster: require('@/assets/blog-9.webp'),
				desc: 'Wondering if you can use GBWhatsApp and WhatsApp with the same number? Learn the risks, limitations, and best practices for dual messaging apps.',
				name: 'en-blog9',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/can-i-use-gbwhatsapp-and-whatsapp-with-same-number/',
				date: '01/08/2025',
			},
			{
				title: 'How to Restore Deleted Media on GBWhatsApp Without Backup',
				poster: require('@/assets/blog-10.webp'),
				desc: 'Restore GBWhatsApp deleted media quickly without backup using these proven methods. Recover your photos, videos, and audio files effortlessly today.',
				name: 'en-blog10',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/restore-deleted-media-on-gbwhatsapp-without-backup/',
				date: '11/08/2025',
			},
			{
				title: 'Does GBWhatsApp Really Improve Privacy? A Deep Dive',
				poster: require('@/assets/blog-13-1.webp'),
				desc: 'GBWhatsApp promises advanced privacy settings, from hiding online status to locking chats. But does it really improve privacy compared to the official WhatsApp? Here\'s an honest breakdown.',
				name: 'en-blog13',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/gbwhatsapp-privacy/',
				date: '26/09/2025',
			},
			{
				title: 'Safeguard Your Chats: How to Back Up Your Data on GBWhatsApp？',
				poster: require('@/assets/blog-14-1.webp'),
				desc: 'Easily back up GBWhatsApp data to safeguard your chats, photos, and media. Ensure secure storage and seamless recovery with verified backup methods.',
				name: 'en-blog14',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/backup-gbwhatsapp-data/',
				date: '20/10/2025',
			},
			{
				title: 'Exploring GBWhatsApp\'s Hidden Gem: The Voice Changer Feature',
				poster: require('@/assets/blog-15-1.webp'),
				desc: 'A deep look into GBWhatsApp\'s Voice Changer — how it works, how to enable it, and why users love this fun, expressive tool.',
				name: 'en-blog15',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/gbwhatsapp-voice-changer-feature/',
				date: '27/10/2025',
			},
			{
				title: 'How to Use Live Wallpapers in GBWhatsApp Chat Screen',
				poster: require('@/assets/blog-16-1.webp'),
				desc: 'Bring your chats to life by setting live wallpapers in GBWhatsApp — subtle motion, personal style, and a fresh look for your daily conversations.',
				name: 'en-blog16',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/gbwhatsapp-live-wallpapers/',
				date: '04/11/2025',
			},
		],
		mods: [
		
			{
				title: 'What is Blue WhatsApp Plus?',
				poster: require('@/assets/blog-4.webp'),
				desc: 'Explore what Blue WhatsApp Plus offers, from extra features to privacy upgrades. Discover how it differs from the official WhatsApp in our full guide.',
				name: 'en-blog4',
				column: 'WhatsApp Mods',
				url: 'https://gbwaapplus.com/what-is-blue-whatsapp-plus/',
				date: '27/5/2025',
			},
			{
				title: 'What is WhatsApp Aero?',
				poster: require('@/assets/blog-12.webp'),
				desc: 'WhatsApp Aero brings flexible design, privacy tools, and improved media sharing to Android. Ideal for users who love personalization and a unique interface beyond regular WhatsApp.',
				name: 'en-blog12',
				column: 'Tutorial',
				url: 'https://gbwaapplus.com/what-is-whatsapp-aero/',
				date: '28/08/2025',
			},
		],
		shooting: [
			{
				title: 'How to Use GB WhatsApp without Being Banned ',
				poster: require('@/assets/gbwhatsapp-anti-ban.webp'),
				desc: 'Discover how GB WhatsApp’s Anti Revoke messages feature lets you read deleted chats, enhancing your control, clarity, and messaging experience.',
				name: 'en-blog3',
				column: 'Troubleshooting',
				url: 'https://gbwaapplus.com/use-gb-whatsapp-without-being-banned/',
				date: '19/5/2025',
			},
			{
				title: 'GB WhatsApp Support: How to Get Help & Fix Issues',
				poster: require('@/assets/gbWhatsappSupport.webp'),
				desc: 'GB WhatsApp Support helps users resolve login errors, feature glitches, and update problems quickly. Learn how to get the right assistance and fix issues fast.',
				name: 'en-blog8',
				column: 'Troubleshooting',
				url: 'https://gbwaapplus.com/gb-whatsapp-support-how-to-get-help-and-fix-issues/',
				date: '20/07/2025',
			},
			{
				title: 'How to Fix GBWhatsApp Not Working on Android',
				poster: require('@/assets/blog-11.webp'),
				desc: 'How to fix GBWhatsApp not working on Android with easy steps to solve crashes, connection errors, and update problems quickly.',
				name: 'en-blog11',
				column: 'Troubleshooting',
				url: 'https://gbwaapplus.com/how-to-fix-gbwhatsapp-not-working-on-android/',
				date: '19/08/2025',
			},
			{
				title: 'How to Fix GB WhatsApp Not Sending or Receiving Messages',
				poster: require('@/assets/blog-17.webp'),
				desc: 'Comprehensive solutions for GB WhatsApp not sending or receiving messages. Step-by-step troubleshooting for sending and receiving failures, network issues, and connection errors.',
				name: 'en-blog17',
				column: 'Troubleshooting',
				url: 'https://gbwaapplus.com/fix-gbwhatsapp-message-sending-receiving/',
				date: '18/11/2025',
			},
		],
		news: [
			{
				title: 'New Release: GB WhatsApp Updated v18.50 Version',
				poster: require('@/assets/gbWhatsAppUpdated.webp'),
				desc: 'GB WhatsApp v18.50 is here with better privacy, new features, smoother performance, and full customization. Download the latest version now!',
				name: 'en-blog7',
				column: 'News',
				url: 'https://gbwaapplus.com/new-release-gb-whatsapp-updated-v18.50-version/',
				date: '07/07/2025',
			},
		],
	},
}
